<template>
    <ui-steps-manager>
        <template #step>
            <div class="container-payment">
                <div class="payment-header">
                    <div class="plan-payment" :class="{ 'plan-payment-not-select': form.fields.units.show === false }">Plano de Pagamento</div>

                    <div v-show="form.fields.units.show" class="select-header">
                        <ui-select-v2
                            v-model="form.data.units"
                            :data="unitsAvailable"
                            :disabled="form.fields.units.disabled"
                            :show-apply-button="false"
                            label="Selecionar Unidades:"
                            design="mgb-15 br-all"
                            multiple
                            item-label="label"
                            size="lg"
                            placeholder="Selecione uma unidade"
                            align
                        />
                    </div>
                </div>

                <div class="bonus-units">
                    <span v-if="paymentBonus" class="bonus-applied-units">
                        Bônus de {{ paymentBonus | currencyBRL}} aplicado às unidades selecionadas.
                    </span>

                    <span v-if="!unitsHaveReserves" class="units-have-no-reserves">
                        O cliente/negócio não possui reserva(s) para a(s) unidade(s) selecionada(s) ou vinculada a simulação.
                    </span>

                    <fieldset v-if="simulationObservation" class="simulation-observation">
                        <legend>Observação da Simulação:</legend>
                        <span>
                            {{ simulationObservation }}
                        </span>
                    </fieldset>

                    <div class="value-units">
                        <div class="amount">
                            <div class="amount-change" @click="changeReservedUnitsValueHandler">
                                Valor total da(s) unidade(s):
                                <span class="change">Alterar</span>
                            </div>

                            <div class="value-amount">
                                <span class="value">{{ totalValue | currencyBRL }}</span>
                            </div>
                        </div>

                        <div class="total-entry-amount">
                            Valor total a ser pago:

                            <div class="value-entry">
                                <span class="value">{{ entryValue | currencyBRL }}</span>
                            </div>
                        </div>

                        <div :class="{ 'missing': missingValue < 0 }" class="summary-receipt">
                            Resumo de Recebimentos:

                            <div class="value-summary">
                                <span class="value">{{ summaryValue | currencyBRL }}</span>
                            </div>

                            <div v-if="missingValue < 0" class="missing-value">
                                Valor faltante: {{ missingValue | currencyBRL }}
                            </div>

                            <div v-else-if="missingValue > 0" class="surplus-value">
                                Valor excedente: {{ missingValue | currencyBRL }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="add-payment">
                    <span class="text-add-payment">Adicionar Pagamento</span>

                    <div class="select-add-payment">
                        <ui-select-v2
                            v-model="form.data.payment_option"
                            :data="paymentOptions"
                            :placeholder="form.fields.payment_option.planceholder"
                            :item-label="form.fields.payment_option.item_label"
                            :multiple="form.fields.payment_option.multiple"
                            :disabled="!unitsHaveReserves"
                            :show-apply-button="false"
                            :label="form.fields.payment_option.label"
                            size="lg"
                            design="mgb-15 br-all"
                        />
                    </div>
                </div>

                <div class="select-table">
                    <div class="select-table-content">
                        <div class="category-subcategory">
                            <ui-select-v2
                                v-model="form.data.payment.category"
                                :data="categoryOptions"
                                :loading="loader.category"
                                required
                                item-label="name"
                                label="Categoria:"
                                design="mgb-15 br-all"
                                @input="categoryHandler"
                            />

                            <ui-select-v2
                                v-model="form.data.payment.subcategory"
                                :data="subcategoryOptionsComputed"
                                :loading="loader.subcategory"
                                :required="form.fields.subcategory.required"
                                item-label="name"
                                label="Subcategoria:"
                                design="mgb-15 br-all"
                                @input="subcategoryHandler"
                            />
                        </div>

                        <div class="observation">
                            <ui-input
                                v-model="form.data.payment.observations"
                                :required="form.fields.observations.required"
                                type="text"
                                label="Observação:"
                                placeholder="Digite..."
                            />
                        </div>

                        <div class="value-input">
                            <div class="money">
                                <ui-input-money
                                    v-model="form.data.payment.value"
                                    :required="form.fields.value.required"
                                    label="Valor:"
                                    group
                                />
                            </div>

                            <div class="button-table">
                                <ui-button :disabled="!canAddPayment" @click="addPaymentHandler">
                                    <em class="fal fa-plus" />
                                </ui-button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="table-payment">
                    <ui-table-payment :contents="form.data.payments" />
                </div>

                <div class="button-payment-footer">
                    <ui-button
                        v-if="allowReprintVoucher"
                        design="primary md mw-150"
                        @click="printVoucherHandler">
                        Reimprimir Pagamento
                    </ui-button>

                    <ui-button
                        :disabled="!canRegisterPayment"
                        :loading="loader.register"
                        design="success md mw-150"
                        @click="registerHandler">
                        Registrar Pagamento
                    </ui-button>
                </div>

                <ui-modal-info
                    :action="register"
                    name="launch-payment-register-confirm"
                    title="Existe um valor excedente. Tem certeza que deseja salvar mesmo assim?"
                    icon="fal fa-question-circle"
                    color-circle="#FF7D00"
                    btn-text="Salvar"
                    btn-type="success"
                    icon-circle
                    footer
                    can-submit
                />
            </div>

            <ui-change-value-reserved-units-modal />
            <ui-payment-voucher />
            <ui-financial-analysis-modal v-if="control?.deal?.simulation" :data="control.deal.simulation" />
        </template>
    </ui-steps-manager>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiSelectV2, uiInput, uiInputMoney } from '@/components/ui/form'
    import { uiModalInfo } from '@/components/ui/modal'
    import { uiFinancialAnalysisModal } from '@/components/ui-facilita/modals'
    import uiChangeValueReservedUnitsModal from './components/change-value-reserved-units-modal'
    import uiTablePayment from './components/table-payment'
    import uiStepsManager from '../components/steps-manager'
    import uiPaymentVoucher from './components/payment-voucher'

    import { launchDay } from '@/services/axios'
    import store from '@/store'

    import { currencyBRL } from '@/filters'
    import { utilMixin } from '@/mixins'

    import { mapGetters, mapActions } from 'vuex'

    const defaultPaymentData = () => ({
        value: 0,
        observations: '',
        category: null,
        subcategory: null
    })

    const defaultFormData = () => ({
        payment_option: null,
        units: [],
        payment: { ...defaultPaymentData() },
        payments: []
    })

    const defaultLoader = () => ({
        category: false,
        subcategory: false,
        register: false
    })

    export default {
        name: 'ui-payment',

        components: {
            uiStepsManager,
            uiButton,
            uiSelectV2,
            uiInput,
            uiTablePayment,
            uiInputMoney,
            uiChangeValueReservedUnitsModal,
            uiModalInfo,
            uiPaymentVoucher,
            uiFinancialAnalysisModal
        },

        filters: { currencyBRL },

        mixins: [utilMixin],

        beforeRouteEnter(to, from, next) {
            if (!(store.state.launchDay.definitions &&
                store.state.launchDay.definitions.launchday)) {
                next('/lancamentos/gerenciamento/controle-ponto-atendimento')
            }

            // Verifica se o usuário logado possui foi cadastrado como um operador de caixa
            launchDay.get('boxes/launchday_id/', `${store.state.launchDay.definitions.launchday.id}/permission`)
                .then(response => {
                    if (!Object.keys(response.data).length) {
                        response.data.msg = 'Este usuário não está configurado como um operador de caixa!'
                        return Promise.reject(response)

                    } else {
                        store.dispatch('launchDay/setLaunchdayBox', { ...response.data })
                        next()
                    }
                })
                .catch(error => {
                    if (error.data && error.data.msg) {
                        next(vm => {
                            vm.$toastr.e(error.data.msg)
                            next('/lancamentos/gerenciamento/controle-ponto-atendimento')
                        })
                    }
                    console.log(error)
                })
        },

        data() {
            return {
                form: {
                    data: { ...defaultFormData() },
                    fields: {
                        units: {
                            disabled: false,
                            show: true
                        },
                        category: {
                            required: true
                        },
                        subcategory: {
                            required: true
                        },
                        observations: {
                            required: false
                        },
                        value: {
                            required: true
                        },
                        payment_option: {
                            label: 'Plano de Pagamento:',
                            item_label: 'name',
                            placeholder: 'Selecione um plano de pagamento',
                            multiple: false,
                            disabled: false
                        }
                    }
                },
                loader: { ...defaultLoader() },
                paymentTypeLabels: {
                    act: 'Ato',
                    signal: 'Entrada',
                    unique: 'Única',
                    fixed_value: 'Valor Fixo',
                    monthly: 'Mensal',
                    bimonthly: 'Bimestral',
                    quarterly: 'Trimestral',
                    four_monthly: 'Quadrimestral',
                    semester: 'Semestral',
                    yearly: 'Anual',
                    intermediary: 'Intermediária',
                    keys: 'Chaves',
                    fgts: 'FGTS',
                    financing: 'Financiamento',
                    allowance: 'Subsídio',
                    bonus: 'Bonificação',
                    assets_rights: 'Bem e Direito'
                },
                categoryOptions: [],
                subcategoryOptions: [],
                paymentOptions: [],
                allowReprintVoucher: false
            }
        },

        computed: {
            ...mapGetters('launchDay', {
                control: 'getControl',
                definitions: 'getDefinitions',
                load: 'getPreLoad'
            }),
            /**
             * Computed property que retorna a disponibilidade do produto vinculado ao lançamento
             */
            productAvailability() {
                return this.control.deal &&
                    this.control.deal.product &&
                    this.control.deal.product.availability
                        || null
            },
            /**
             * Computed property que retorna as unidades reservadas pelo usuário, e que estão
             * disponíveis para realizar o pagamento
             */
            unitsAvailable() {
                let units = []
                /**
                 * As unidades das reservas do produto vinculado ao lançamento são listadas apenas
                 * para o cliente/negócio que não possui simulação/proposta
                 */
                if (this.control &&
                    this.control.deal &&
                    this.$mx_hasValue(this.control.deal.reserves) &&
                    !this.control.deal.simulation) {
                    units = Object.values(this.control.deal.reserves)
                        .filter(reserve => reserve.status === 'reserved' &&
                            (this.productAvailability &&
                                this.productAvailability.id === reserve.units.availability_id))
                        .map(reserve => {
                            let unit = { ...reserve.units }
                            // Constrói o label para a unidade de acordo com o tipo de disponibilidade
                            unit.label = this.productAvailability && this.productAvailability.type === 'vertical'
                                ? `Torre ${unit.block} - Andar ${unit.floor} - Unidade ${unit.number}`
                                : `Quadra ${unit.block} - Lote ${unit.number}`
                            unit.label += ` - ${this.$options.filters.currencyBRL(unit.cost)} - #${unit.id}`

                            return unit
                        })

                }

                return units
            },
            /**
             * Computed property que define se o cliente/negócio possui reservas para todas as unidades
             * selecionadas. No caso dos negócios com simulação/proposta, verifica se a unidade foi
             * reservada.
             */
            unitsHaveReserves() {
                let result = true
                if (this.control && this.control.deal && this.$mx_hasValue(this.form.data.units)) {
                    const reservedUnits = this.$mx_hasValue(this.control.deal.reserves)
                        ? Object.values(this.control.deal.reserves)
                            .filter(reserve => reserve.status === 'reserved' &&
                                (this.productAvailability &&
                                    this.productAvailability.id === reserve.units.availability_id))
                            .map(reserve => reserve.units.id)
                        : []
                    result = Object.values(this.form.data.units).every(unit => reservedUnits.includes(unit.id))
                }

                return result
            },
            /**
             * Computed property que retorna o texto de observações da simulação, caso esta possua
             */
            simulationObservation() {
                return this.control &&
                    this.control.deal &&
                    this.control.deal.simulation &&
                    this.control.deal.simulation.observation
            },
            /**
             * Computed property que filtra as subcategorias, de acordo com a categoria
             * selecionada
             */
            subcategoryOptionsComputed() {
                return this.form.data.payment.category
                    ? Object.values(this.subcategoryOptions)
                        .filter(option => option.category_id === this.form.data.payment.category.id)
                    : []
            },
            /**
             * Computed property que valida o formulário de pagamento e se as unidades selecionadas
             * possuem reservas, de modo à definir se o pagamento pode ser adicionado ou não
             */
            canAddPayment() {
                return this.validatePaymentForm().valid &&
                    this.form.data.units.length &&
                    this.$mx_hasValue(this.form.data.payment_option) &&
                    this.unitsHaveReserves
            },
            /**
             * Computed property que retorna o bonus dado no pagamento das unidades, de acordo com
             * o plano de pagamento selecionado
             */
            paymentBonus() {
                // Esta regra vale apenas para quando não há simulação, se houver o bonus é 0
                return (!this.form.fields.payment_option.multiple &&
                    this.form.data.payment_option &&
                    parseFloat(this.form.data.payment_option.bonus)) ||
                        0
            },
            /**
             * Computed property que retorna o valor total do investimento, com o valor dos descontos já
             * deduzidos das unidades
             */
            totalValue() {
                /**
                 * Caso as opções de pagamento sejam planos de pagamento, verifica se o plano selecionado
                 * possui desconto
                 */
                const discountPercent = (!this.form.fields.payment_option.multiple &&
                    this.form.data.payment_option &&
                    this.form.data.payment_option.discount_entrance) ||
                        0

                return this.$mx_hasValue(this.form.data.units)
                    ? Object.values(this.form.data.units)
                        .map(unit => {
                            const costWithoutBonus = parseFloat(unit.cost || 0) - parseFloat(this.paymentBonus)

                            return costWithoutBonus * (1 - discountPercent / 100)
                        })
                        .reduce((sum, cost) => sum + cost, 0)
                    : 0
            },
            /**
             * Computed property que retorna o valor à ser pago pelo cliente/negócio de acordo com as
             * opções de pagamento escolhidas. No caso de o cliente/negócio possuir uma simulação, as
             * opções de pagamento são as parcelas da simulação
             */
            entryValue() {
                let value = 0

                if (this.$mx_hasValue(this.form.data.payment_option)) {
                    if (this.form.fields.payment_option.multiple) {
                        /**
                         * Parcelas do tipo Única, Entrata, Ato, Valor Fixo e Intermediária, consideram o valor
                         * total da parcela como o valor a ser cobrado. Já os demais tipos consideram apenas a
                         * primeira prestação
                         */
                        value = Object.values(this.form.data.payment_option)
                            .map(installment => {
                                return [
                                    'signal',
                                    'unique',
                                    'act',
                                    'fixed_value',
                                    'intermediary'
                                ].includes(installment.type_installment)
                                    ? parseFloat(installment.first_value) * parseInt(installment.quantity)
                                    : parseFloat(installment.first_value)
                            })
                            .reduce((sum, cost) => sum + cost, 0)

                    } else {
                        value = this.totalValue * (parseInt(this.form.data.payment_option.entrance) / 100)
                    }
                }

                return value
            },
            /**
             * Computed property que retorna o valor total pago pelo cliente/negócio, de acordo com as
             * formas de pagamento escolhidas e valores informados
             */
            summaryValue() {
                return this.$mx_hasValue(this.form.data.payments)
                    ? Object.values(this.form.data.payments)
                        .map(payment => payment.value)
                        .reduce((sum, cost) => sum + cost, 0)
                    : 0
            },
            /**
             * Computed property que retorna a diferença entre o valor de entrada e o resumo dos pagamentos,
             * de forma a informar o valor faltante ou excedente do pagamento
             */
            missingValue() {
                return (this.summaryValue - this.entryValue).toFixed(2)
            },
            /**
             * Computed property que habilita ou desabilita o registro de pagamentos
             */
            canRegisterPayment() {
                return !!this.form.data.payments.length &&
                    this.missingValue >= 0 &&
                    !this.allowReprintVoucher
            }
        },

        created() {
            /** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe((mutation) => {
                if (mutation.type === 'launchDay/SET_CONTROL_DEAL') {
                    // Limpa o formulário
                    this.form.data = { ...defaultFormData() }
                    // Desabilita o botão de reimpressão dos comprovantes de pagamento
                    this.allowReprintVoucher = false

                    if (this.definitions &&
                        this.definitions.launchday &&
                        this.control.deal &&
                        this.control.deal.simulation &&
                        this.control.deal.simulation.unity) {
                        this.form.data.units = [{ ...this.control.deal.simulation.unity }]
                        this.form.fields.units.show = false
                        this.form.fields.units.disabled = true
                        /*
                         * Caso o cliente/negócio possua uma simulação, o pagamento deverá ser definido de acordo
                         * com as séries dos tipos de parcela configurados no lançamento
                         */
                        const paymentTypes = this.definitions.launchday.attributes &&
                            this.definitions.launchday.attributes.typesOfPayments
                                ? [...this.definitions.launchday.attributes.typesOfPayments]
                                : []
                        this.paymentOptions = this.control.deal.simulation.installments
                            ? Object.values(this.control.deal.simulation.installments)
                                .filter(installment => paymentTypes.includes(installment.type_installment))
                                .map(installment => {
                                    installment.label = this.paymentTypeLabels[installment.type_installment]

                                    return installment
                                })
                            : []
                        this.form.fields.payment_option.label = 'Série de Parcelas:'
                        this.form.fields.payment_option.item_label = 'label'
                        this.form.fields.payment_option.placeholder = 'Selecione uma série de parcelas da simulação'
                        this.form.fields.payment_option.multiple = true
                        this.form.data.payment_option = []

                    } else {
                        this.form.fields.units.show = true
                        this.form.fields.units.disabled = false
                        /**
                         * Caso não haja uma simulação, o pagamento é definido pelos planos de pagamento
                         */
                        const paymentPlans = this.definitions.launchday.attributes &&
                            this.definitions.launchday.attributes.tableValues &&
                            typeof this.definitions.launchday.attributes.tableValues === 'string'
                                ? JSON.parse(this.definitions.launchday.attributes.tableValues)
                                : []
                        this.paymentOptions = paymentPlans.map((plan, index) => {
                            plan.id = index

                            return plan
                        })
                        this.form.fields.payment_option.label = 'Plano de Pagamento:'
                        this.form.fields.payment_option.item_label = 'name'
                        this.form.fields.payment_option.placeholder = 'Selecione um plano de pagamento'
                        this.form.fields.payment_option.multiple = false
                        this.form.data.payment_option = null
                    }
                }
            })

            // Trata o evento de quando a remoção de um pagamento é requerida
            this.$root.$on('payment-table-remove-item', (payload) => {
                const index = this.form.data.payments.findIndex(payment => payment.id === payload)
                if (index >= 0) this.form.data.payments.splice(index, 1)
            })

            /**
             * Trata o evento de quando o modal de alteração dos valores das unidades é fechado,
             * de modo a atualizar os valores das unidades caso alguma tenha sido alterada
             */
            this.$root.$on('modal-close-change-value-reserved-units', () => {
                this.loadControlDeal({ code: this.control.deal.id, type: 'cod' })
            })
        },

        mounted() {
            this.loadForm()
        },

        beforeDestroy() {
            this.unsubscribe()
            this.$root.$off('payment-table-remove-item')
            this.$root.$off('modal-close-change-value-reserved-units')
        },

		methods: {
            ...mapActions('launchDay', ['loadControlDeal']),
            /**
             * Abre o modal para alterar os valores das unidades reservadas que foram selecionadas,
             * ou a unidade vinculada à simulação/proposta do cliente/negócio
             */
			changeReservedUnitsValueHandler() {
				this.$root.$emit('modal-open-change-value-reserved-units', {
                    reserved_units: [...this.form.data.units],
                    availability: { ...this.productAvailability },
                    launchday_id: this.definitions.launchday.id
                })
			},
            /**
             * Realiza as requisições e formatações dos dados necessários para a montagem do formulário
             */
            loadForm() {
                this.loadFieldOptions('category', 'categories')
                this.loadFieldOptions('subcategory', 'subcategories')
            },
            /**
             * Carrega as opções do select de categorias e subcategorias, dependendo dos
             * parâmetros passados
             */
            loadFieldOptions(field, url) {
                if (!(this.definitions && this.definitions.launchday)) return

                this.loader[field] = true
				launchDay.getAll(url, {})
					.then(response => {
                        const options = Object.values(response.data).filter(option => {
                            return option.launchday_id === this.definitions.launchday.id
                        })
						if (field === 'category') {
							this.categoryOptions = options

						} else {
							this.subcategoryOptions = options
						}
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log(error)
					})
					.finally(() => {
						this.loader[field] = false
					})
            },
            /**
             * Event handler que trata o evento de quando uma subcategoria é selecionada,
             * de modo a definir se o campo de observação será requerido para o pagamento
             */
            subcategoryHandler() {
                this.form.fields.observations.required = !!(this.form.data.payment.subcategory &&
                    this.form.data.payment.subcategory.attributes &&
                    this.form.data.payment.subcategory.attributes.observations)
            },
            /**
             * Valida a propriedade required dos campos do formulário
             */
            validateRequired(field, form = null) {
                const required = this.form.fields[field].required
                const value = !form ? this.form.data[field] : this.form.data[form][field]
                const validation = this.$mx_hasValue(value) || parseInt(value) === 0

                return (required && validation) || !required
            },
            /**
             * Valida os campos do formulário de acordo com diferentes conjuntos de regras
             */
            validatePaymentForm() {
                let valid = true
                let message = '<ul>'

                if (!this.validateRequired('category', 'payment')) {
                    valid = false
                    message += '<li>É necessário selecionar uma categoria.</li>'
                }

                if (!this.validateRequired('subcategory', 'payment')) {
                    valid = false
                    message += '<li>É necessário selecionar uma subcategoria.</li>'
                }

                if (!this.validateRequired('observations', 'payment')) {
                    valid = false
                    message += '<li>É necessário informar uma observação.</li>'
                }

                if (!this.validateRequired('value', 'payment')) {
                    valid = false
                    message += '<li>É necessário informar o valor do pagamento.</li>'
                }

                message += '</ul>'

                return { valid, message }
            },
            /**
             * Event handler que trata o evento de quando o cadastro de um pagamento é requerido
             */
            addPaymentHandler() {
                const id = Math.floor((Math.random() * Date.now()) + 1)
                this.form.data.payments.push({ id, ...this.form.data.payment })
                this.form.data.payment = { ...defaultPaymentData() }
            },
            /**
             * Solicita o registro dos pagamentos cadastrados
             */
            registerHandler() {
                if (this.missingValue > 0) {
                    this.$root.$emit('modal-open-launch-payment-register-confirm')

                } else {
                    this.register()
                }
            },
            /**
             * Event handler que trata o evento de quando a impressão do comprovante de pagamento
             * é requerida
             */
            printVoucherHandler() {
                let payload = {
                    units: [...this.form.data.units],
                    availability: { ...this.productAvailability },
                    entry_value: this.entryValue,
                    total_value: this.totalValue,
                    summary_value: this.summaryValue,
                    created_at: Date.now(),
                    payments: [...this.form.data.payments],
                    copies: 'broker'
                }

                // Verifica se a via do cliente será impressa
                if (this.definitions.launchday.attributes.via_cliente) {
                    payload.copies += ',customer'
                }

                // Verifica se a via do caixa será impressa
                if (this.definitions.launchday.attributes.via_caixa) {
                    payload.copies += ',box'
                }
                this.$root.$emit('print-payment-voucher', payload)
            },
            /**
             * Realiza o registro dos pagamentos informados pelo cliente/negócio
             */
            register: async function () {
                // Fecha o modal de confirmação do pagamento
                if (this.missingValue > 0) this.$root.$emit('modal-close-launch-payment-register-confirm')

                try {
                    this.loader.register = true
                    const selectedUnitsId = Object.values(this.form.data.units).map(unit => unit.id)
                    const params = {
                        reserves: Object.values(this.control.deal.reserves)
                            .filter(reserve => selectedUnitsId.includes(reserve.units.id) && reserve.status === 'reserved')
                            .map(reserve => reserve.id),
                        payments: Object.values(this.form.data.payments).map(payment => ({
                            category_id: payment.category.id,
                            subcategory_id: payment.subcategory ? payment.subcategory.id : null,
                            observations: payment.observations,
                            value: payment.value
                        }))
                    }

                    let response = await launchDay.create(`boxes/${this.definitions.launchday_box.id}/payment`, params)
                    if (response.data && response.data.msg) this.$toastr.s(response.data.msg)

                    const checkinParams = {
                        model: 'Deal_Main',
                        id: this.control.deal.id,
                        points_id: this.definitions.launchday_point_id,
                        situation: 'finalizado'
                    }
                    response = await launchDay.create('checkin', checkinParams)

                    this.allowReprintVoucher = true
                    this.printVoucherHandler()

                    // Recarrega os dados do negócio
                    this.loadControlDeal({ code: this.control.deal.id, type: 'cod' })

                } catch (error) {
                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    console.log(error)

                } finally {
                    this.loader.register = false
                }
            },
            /**
             * Event handler que trata o evento de quando uma categoria é selecionada, de
             * modo a limpar a última seleção de subcategoria
             */
            categoryHandler() {
                this.form.data.payment.subcategory = null
            }
		}

    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>